<template>
  <div>
    <v-card>
      <v-card-title class="font-weight-black black--text">
        {{ $t("languagePreferences") }}
      </v-card-title>
      <v-card-subtitle class="black--text">
        Please choose your preferred language.
      </v-card-subtitle>
      <v-card-text width="100%">
        <v-row>
          <v-col cols="6">
            <v-card flat>
              <v-card-text>
                <v-row>
                  <v-col cols="6" sm="6">
                    <label
                      class="subtitle-1 font-weight-medium black--text"
                      for="Select Language"
                      >Select Language</label
                    >
                    <v-select
                      :items="langData"
                      item-text="name"
                      item-value="value"
                      outlined
                      dense
                      v-model="settings.language"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="pt-10 text-center" cols="6"></v-col>
        </v-row>
        <v-card-title class="font-weight-black black--text text">
          Unit Preference
        </v-card-title>
        <!-- <v-card-subtitle class="black--text">
                    Please choose your preferred language.
                </v-card-subtitle> -->
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols="6" sm="6">
                <label
                  class="subtitle-1 font-weight-medium black--text"
                  for="Select Language"
                  >Select unit of measure</label
                >
                <div class="d-flex">
                  <v-select
                    :items="weightUnits"
                    item-text="name"
                    item-value="value"
                    outlined
                    dense
                    class="shrink mr-2 wdt"
                    v-model="settings.weightUnit"
                  ></v-select>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="updateUserSettings"
            right
            height="44"
            width="116"
            depressed
            color="primary"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import loading from "@/mixins/LoadingMixin";
import { userSettings } from "@/graphql/Users.gql";
import gql from "graphql-tag";

export default {
  async mounted() {
    await this.$apollo.queries.settings.refetch();
  },
  data: () => ({
    settings: {},
    langData: [
      { name: "English", value: "en" },
      { name: "Hindi", value: "hi" },
    ],
    weightUnits: [
      { name: "kg", value: "KG" },
      { name: "lbs", value: "LBS" },
    ],
    user: {
      currentPassword: "",
      newPassword: "",
      newPasswordConfirm: "",
    },
  }),
  methods: {
    updateUserSettings() {
      console.log(this.settings.weightUnit, this.settings.language);

      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($data: CreateUserSettingInput!) {
              createUserSetting(createUserSettingInput: $data) {
                userId
                language
                weightUnit
              }
            }
          `,
          variables: {
            data: {
              weightUnit: this.settings.weightUnit,
              language: this.settings.language,
            },
          },
        })
        .then(async res => {
          console.log(res);
          if (res.data.createUserSetting && res.data.createUserSetting.userId) {
            this.$notify({
              title: "Updated",
              text: res.message,
              type: "success",
            });
          }
        })
        .catch(async error => {
          console.log(error);
          this.stopLoading();
        });
    },
  },
  mixins: [loading],
  apollo: {
    settings: {
      query: userSettings,
      variables: {
        userSpecific: true,
      },
      update: data => data?.userSettings,
    },
  },
};
</script>

<style lang="scss">
.v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense
  .v-select__selections {
  padding: 4px 0 10px 0;
}

.text {
  font-weight: 700;
  font-size: 22px;
  line-height: 38px;
}

.v-select.v-text-field--outlined:not(.v-text-field--single-line)
  .v-select__selections {
  width: 264px;
}
.v-select__selections {
  align-items: center;
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  line-height: 21px;
  max-width: 100%;
  min-width: 0;
}
</style>
